"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  wrapInScriptTags: function wrapInScriptTags(scriptId, scriptBody) {
    if (!scriptBody) {
      return '';
    }
    return "\n<script id=\"".concat(scriptId, "\">\n").concat(scriptBody, "\n</script>");
  }
};
exports["default"] = _default;